export default __webpack_public_path__ + "static/media/hsbc.c5a12975.svg";